/*
 * Modal (Micromodal)
 */
import MicroModal from 'micromodal';

let modalScrollY = 0;

MicroModal.init({
	onShow: modal => {
		modalScrollY = window.scrollY;

		// YouTube iframe の読み込み
		const iframes = modal.querySelectorAll('iframe[data-src]');
		iframes.forEach(iframe => {
			iframe.src = iframe.dataset.src;
		});

		//console.log(`${modal.id} is shown`);
	},
	onClose: modal => {
		const videos = modal.querySelectorAll('video');
		videos.forEach(video => video.pause());

		// YouTube iframe の停止
		const iframes = modal.querySelectorAll('iframe[data-src]');
		iframes.forEach(iframe => {
			iframe.src = '';
		});

		setTimeout(() => {
			window.scrollTo(0, modalScrollY);
		}, 0);

		//console.log(`${modal.id} is hidden`);
	},
	openTrigger: 'data-micromodal-trigger',
	closeTrigger: 'data-micromodal-close',
	openClass: 'is-open',
	disableScroll: true,
	disableFocus: false,
	awaitOpenAnimation: false,
	awaitCloseAnimation: false,
	debugMode: false,
});
